var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWifiGood = function SvgWifiGood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 16 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.73 3.563c.403.404.783.864 1.115 1.344a.75.75 0 1 1-1.235.852A7.967 7.967 0 0 0 2.4 4.623c-.32.322-.64.712-.932 1.133a.75.75 0 0 1-1.233-.855c.34-.49.716-.95 1.105-1.338a9.47 9.47 0 0 1 13.39 0m-2.14 1.888c.473.473.88 1.045 1.192 1.653a.75.75 0 1 1-1.335.683c-.239-.47-.548-.9-.918-1.275a4.942 4.942 0 0 0-7.904 1.26.75.75 0 0 1-1.338-.677A6.443 6.443 0 0 1 12.59 5.451m-1.635 2.39c.363.363.662.808.87 1.282a.75.75 0 1 1-1.375.602 2.7 2.7 0 0 0-.556-.824 2.63 2.63 0 0 0-3.72 0 2.7 2.7 0 0 0-.547.814.75.75 0 1 1-1.374-.601 4.2 4.2 0 0 1 .86-1.274 4.13 4.13 0 0 1 5.842.001m-2.034 2.04a1.243 1.243 0 1 1-1.757 1.756 1.243 1.243 0 0 1 1.757-1.755z"
  })));
};
export default SvgWifiGood;